<template>
  <div class="customerService TopHeadder">
      <!-- 智能客服 -->
      <div class="bannerBox">
          <img src="../../assets/image/c_banner.png" />
           <div class="bannerTitle">
             <h3>语音中间件平台WiDilink</h3>
             <p>快速构建高性价比、电信级稳定的呼叫系统</p>
          </div>
      </div>
     <div class="market_item1 PublicPadding">
         <h4 class="title">产品介绍</h4>
         <p>智语网络语音中间件平台WiDiLink，是一个提供多种开发接口的电话语音平台系统，融合了CTI中间件、IVR、坐席接口、录音、统计等呼叫中心各种相关设备功能。用户的业务系统无需关注呼叫中心系统
底层设备开发，调用简单接口即可实现呼叫、放音、会议、TTS、AS等各种电话功能，帮助系统集成商快速开发出功能强大、高性价比、电信级稳定的呼叫系统，如企业客服热线呼叫中心、营销型外呼系统、政府热线类呼叫中心等。</p>
         <i><img src="../../assets/image/c1_1.png"/></i>
     </div>
     <div class="market_item4 PublicPadding colorbg">
        <h4 class="title">产品功能</h4>
        <ul>
           <li class="c1_li">
              <i><img src="../../assets/image/yy2.png"/></i>
              <h3>人工坐席服务</h3>
              <p>人工坐席服务来电自动弹出客户资料，快速响应用户需求，在服务过程中记录详细的服务内容，并保留完整的服务记录。支持来电弹屏、软电话、排队窗口、软电话与话机同步等功能</p>
           </li>
           <li class="d4_li1 c1_li">
              <i><img src="../../assets/image/yy3.png"/></i>
              <h3>语音自助服务IVR</h3>
              <p>通过自助语音导航，引导用户服务需求到相应座席受理，提高服务效率、减少人力成本。支持流程在线编辑、多流程运行等功能</p>
           </li>
            <li class="d4_li1 c1_li">
              <i><img src="../../assets/image/yy4.png"/></i>
              <h3>个性化ACD</h3>
              <p>支持个性化的来电分配机制以及动态的排队和路由策略，保证客户服务需求以最短的时间被转接到最合适的座席</p>
           </li>
            <li>
              <i><img src="../../assets/image/yy5.png"/></i>
              <h3>录音管理</h3>
              <p>支持录音检索、回访及录音备份</p>
           </li>
            <li>
              <i><img src="../../assets/image/yy6.png"/></i>
              <h3>服务监控</h3>
              <p>提供队列状态、座席工作状态、IVR状态等服务内容的监控</p>
           </li>
            <li>
              <i><img src="../../assets/image/yy7.png"/></i>
              <h3>数据报表</h3>
              <p>自定义综合统计报表，即配即用，支持从多个统计项中组合出需要的报表</p>
           </li>
        </ul>
     </div>
     <div class="market_item5 PublicPadding">
          <h4 class="title">开发接口与参数</h4>
          <ul>
             <li :class="{active:activeChild==1}" v-on:click="activeTab(1)"> 
                 <i></i>
                 <span>开发接口</span>
             </li>
             <li :class="{active:activeChild==2}" v-on:click="activeTab(2)">
                 <i></i>
                 <span>技术参数</span>
             </li>
          </ul>
          <ol>
              <li v-show="activeChild==1">
                  <div class="m5_div">
                     <h4>HTTP接口</h4>
                     <p> 支持所有HTTP客户端程序</p>
                  </div>
                  <div class="m5_div">
                     <h4>Java原生接口</h4>
                     <p> 支持Java/J2EE/J2ME</p>
                  </div>
                  <div class="m5_div">
                     <h4>.Net原生接口</h4>
                     <p> 支持C#/VB.net/VC.net/ASP.net语言</p>
                  </div>
                  <div class="m5_div m5d_te">
                     <h4>ActiveX控件接口</h4>
                     <p>支持VC/VB/PB/Delphi/CB/C#/JS/ASP等各种开发语言，支持网页JS脚本，兼容PHP、ASP、JSP等Web容器</p>
                  </div>
              </li>
              <li v-show="activeChild==2">
                <div class="m5_div">
                     <p> 支持2000+线大规模并发处理</p>
                  </div>
                  <div class="m5_div">
                     <p> 支持VoIP线路，包括SIP、IMS、H323</p>
                  </div>
                  <div class="m5_div">
                     <p> 支持GSM线路，通过GSM网关对接</p>
                  </div>
                  <div class="m5_div">
                     <p>支持数字中继，包括SS7、SS1、ISDN/PRI</p>
                  </div>
                  <div class="m5_div">
                     <p> 支持模拟线路，包括FXO（模拟线路）、FXS（模拟分机）</p>
                  </div>
                  <div class="m5_div">
                     <p>7x24小时不间断运行</p>
                  </div>
              </li>
          </ol>
     </div>
     <div class="data_item3 PublicPadding">
          <h4 class="title">技术优势</h4>
           <ul>
                <li class="data5_li1"><p>自定义外呼强控策略，充分响应国家政策需求</p></li>
                <li class="data5_li2"><p>自主多平台短信引擎，同时支持无线网关直接短信发送，实现灵动按需短信推送</p></li>
                <li class="data5_li3"><p>多ASR引擎支持，可实现多路平台并行处理</p></li>
                <li class="data5_li4"><p>多方隐私号集成平台，最大可能保护企业的号码资源</p></li>
                <li class="data5_li5"><p>动态号码池技术，遵循“先城市、再省份、后可用”的策略进行智能匹配，尽可能的提高线路资源利用率和接通率</p></li>
           </ul>
      </div>
     <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'customerService',
  data () {
    return {
       activeChild:1,
    }
  },
  components:{
    Popup
  },
   methods:{
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
     activeTab(num) {
       this.activeChild=num
    },
  }
}
</script>


<style scoped>
.bannerTitle{
    left:0.2rem;
}
.bannerTitle h3{
    font-size:0.36rem;
}
.bannerTitle p{
     text-align:left;
}
.market_item1{
  padding-left:0.25rem;
  padding-right:0.25rem;
}
.market_item1 p{
  font-size: 0.2rem;
  font-weight: 400;
  color: #666666;
  line-height: 0.4rem;
  padding: 0.4rem;
  box-shadow: 0 0 0.08rem #ccc;
  margin-top:0.5rem;
  margin-bottom: 0.7rem;
}
.market_item1 i{
  display: block;
  width:7rem;
  height: 15.57rem;
}
.market_item1 i img{
  display: block;
  width:7rem;
  height: 15.57rem;
}
.market_item4 ul{
  width: 7rem;
  margin: 0 auto;
  margin-top:0.4rem;
}
.market_item4 ul li{
  overflow: hidden;
  background: #fff;
  margin-bottom: 0.3rem;
  height: 1.5rem;
  box-shadow: 0 0 0.08rem #ccc;
}
.market_item4 ul li.c1_li{
  height: 2.1rem;
}
.market_item4 ul li.c1_li i{
    margin-top:0.6rem;
}
.market_item4 ul li i{
  float: left;
  width: 1.03rem;
  height: 0.97rem;
  margin:0.24rem 0 0 0.22rem;
}
.market_item4 ul li i img{
  display: block;
  width: 1.03rem;
  height: 0.97rem;
}
.market_item4 ul li h3{
    font-size: 0.24rem;
    font-weight: 400;
    color: #333333;
    padding-left: 1.5rem;
    margin-top:0.3rem;
}
.market_item4 ul li p{
  font-size: 0.22rem;
  font-weight: 400;
  color: #666666;
  margin-top:0.1rem;
  padding-left: 1.5rem;
  padding-right:0.2rem ;
}
.market_item4 ul li.d4_li1 h3{
  margin-top:0.2rem;
}
.market_item5 {
  background:url("../../assets/image/m5_bg.png") no-repeat center;
  background-size:100% 100%;
  height: 7.05rem;
}
.market_item5 .title{
  color: #fff;
}
.market_item5 ul{
  overflow: hidden;
  width: 7rem;
  margin: 0 auto;
  margin-top:0.4rem;
}
.market_item5 ul li{
  float: left;
  width: 3.5rem;
  height: 0.45rem;
  padding-top: 0.2rem;
  background: #fff;
}
.market_item5 ul li.active{
  background: #00C7FF;
}
.market_item5 ul li.active span{
  color: #fff;
}
.market_item5 ul li:first-child i{
  display: inline-block;
  width: 0.32rem;
  height: 0.26rem;
  margin-left:1rem;
  margin-right: 0.1rem;
  background:url("../../assets/image/m5_1.png") no-repeat center;
  background-size:100% 100%;
}
.market_item5 ul li:last-child i{
  display: inline-block;
  width: 0.35rem;
  height: 0.26rem;
  margin-left:1rem;
  margin-right: 0.1rem;
  background:url("../../assets/image/m5_2.png") no-repeat center;
  background-size:100% 100%;
 
}
.market_item5 ul li:first-child.active i{
  background:url("../../assets/image/m5_11.png") no-repeat center;
  background-size:100% 100%;
}
.market_item5 ul li:last-child.active i{
  background:url("../../assets/image/m5_22.png") no-repeat center;
  background-size:100% 100%;
}
.market_item5 ul li span{
  display: inline-block;
  font-size: 0.24rem;
  color: #00C7FF;
  line-height: 0.24rem;
}
.market_item5 ol li{
  width: 6.98rem;
  margin:0 auto;
  border: 0.01rem solid #aaa;
  border-bottom: none;
}
.market_item5 ol li .m5_div {
  height: 1rem;
  border-bottom: 0.01rem solid #aaa;
}
.market_item5 ol li .m5_div h4{
   float: left;
   width:2.1rem;
   color: #fff;   
   font-weight: 400;
   line-height: 1rem;
   text-align: right;
   margin-right:0.2rem;
}
.market_item5 ol li .m5_div p{
   float: left;
   width: 4rem;
   font-size: 0.2rem;
   color: #FFFFFF;
   opacity: 0.5;
   line-height: 1rem;
}
.market_item5 ol li .m5_div.m5d_te p{
   line-height: 0.3rem;  
}
.market_item5 ol li:last-child .m5_div{
    height: 0.8rem;
}
.market_item5 ol li:last-child .m5_div p{
   width: 6rem;
   padding-left:0.2rem ;
   line-height: 0.8rem;
}
.data_item3{
  padding-bottom: 1rem;
}
.data_item3 ul {
    background:url("../../assets/image/c5_bg.png") no-repeat center;
    background-size:100% 100%;
    width:4.65rem;
    height:4.57rem;
    margin:0 auto;
    margin-top:1rem;
    margin-bottom:0.6rem;
    position:relative;
}
.data_item3 ul li p {
    font-size: 0.16rem;
    color: #333333;
    line-height:0.3rem;
    width: 1.5rem;
}
.data_item3 ul li.data5_li1 {
    position:absolute;
    top:-0.3rem;
    left:-0.8rem;
}
.data_item3 ul li.data5_li1 p{
    text-align: right;
    width: 2.4rem;
}
.data_item3 ul li.data5_li2 p{
    text-align: right;
    width: 1.2rem;
}
.data_item3 ul li.data5_li3 p{
    text-align: right;
    width: 2.4rem;
}
.data_item3 ul li.data5_li4 p{
    width: 1.2rem;
}
.data_item3 ul li.data5_li2 {
    position: absolute;
    top:2rem;
    left:-1.2rem;

}
.data_item3 ul li.data5_li3 {
    position: absolute;
    top:-0.1rem;
    right:-1.1rem;
}
.data_item3 ul li.data5_li4 {
    position: absolute;
    top:2.3rem;
    right:-1.2rem;
}
.data_item3 ul li.data5_li5 {
    position: absolute;
    bottom: -0.8rem;
    right: -0.6rem;
}
.data_item3 ul li.data5_li5 p{
    width: 5.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/product/customerService.vue